import React from 'react';
import Modal from 'react-modal';


const MyAddress = ({ isOpen, onRequestClose }) => {

    return (
        <>
            <Modal isOpen={isOpen} onRequestClose={onRequestClose}  >

                <div className='add_details'>
                    <div className='heading d-flex justify-content-center'>
                        <h4>My Adress</h4>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default MyAddress;
